import React, { Component } from 'react';
import { Container, Header, Grid, Input, Button } from 'semantic-ui-react';
import { Map, Marker } from '../components/Map';
import { OptionList, DateOption, FacilityOption } from '../components/Reservation';

class FacilitySelection extends Component {
  render() {
    const { event, blocks, onDateSelect, spots, onChange, inventory, selectedFacility, onFacilitySelect, venue, onCreateReservation } = this.props;
    return (
      <Container>
        <Header className="page title" as="h1" content={`Welcome ${event.name}`} />
        <Header as="h3" content="First, select your parking spots..." />
        <Grid>
          <Grid.Row>
            <Grid.Column width={3} only="tablet computer">
              <Header as="h4" content="Select date(s)" />
            </Grid.Column>
            <Grid.Column width={10} only="tablet computer">
              <OptionList className="date">
                {blocks.map((block, idx) => (
                  <DateOption key={idx} block={block} onClick={onDateSelect} />
                ))}
              </OptionList>
            </Grid.Column>
            <Grid.Column width={3} only="tablet computer"></Grid.Column>
            <Grid.Column width={16} only="mobile">
              <Header as="h4" content="Select date(s)" />
              <OptionList className="date mobile">
                {blocks.map((block, idx) => (
                  <DateOption key={idx} block={block} onClick={onDateSelect} />
                ))}
              </OptionList>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} only="tablet computer">
              <Header as="h4" content="Parking Spot Quantity" />
            </Grid.Column>
            <Grid.Column width={10} only="tablet computer">
              <Input error={spots < 1} name="spots" value={spots} onChange={onChange} />
            </Grid.Column>
            <Grid.Column width={3} only="tablet computer"></Grid.Column>
            <Grid.Column width={16} only="mobile">
              <Header as="h4" content="Parking Spot Quantity" />
              <Input name="spots" value={spots} onChange={onChange} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3} only="tablet computer">
              <Header as="h4" content="Select Parking Facility" />
              <OptionList className="facility">
                {inventory().map((i, idx) => (
                  <FacilityOption
                    key={idx}
                    facility={{ ...i.facility, inventoryId: i.id, selected: selectedFacility ? selectedFacility.id === i.facility.id : false }}
                    onClick={onFacilitySelect}
                    rate={i.rate}
                  />
                ))}
              </OptionList>
            </Grid.Column>
            <Grid.Column width={10} textAlign="center" only="tablet computer">
              <Map center={{ lat: parseFloat(venue.lat), lng: parseFloat(venue.lng) }} zoom={14}>
                <Marker
                  position={{ lat: parseFloat(venue.lat), lng: parseFloat(venue.lng) }}
                  title={venue.name}
                  address={`${venue.address}, ${venue.city}, ${venue.state} ${venue.zip}`}
                  icon={`/img/bluemarker.png`}
                />

                {inventory().map((i, idx) => (
                  <Marker
                    key={idx}
                    position={{ lat: parseFloat(i.facility.lat), lng: parseFloat(i.facility.lng) }}
                    title={i.facility.name}
                    address={`${i.facility.address}, ${i.facility.city}, ${i.facility.state} ${i.facility.zip}`}
                    icon={selectedFacility && selectedFacility.id === i.facility.id ? `/img/selectedmarker.png` : null}
                  />
                ))}
              </Map>
              <div style={{ lineHeight: '40px', display: 'flex', justifyContent: 'space-around' }}>
                <div style={{ display: 'flex' }}>
                  <img alt="" src={`/img/bluemarker.png`} /> = Event Venue
                </div>
                <div style={{ display: 'flex' }}>
                  <img alt="" src={`/img/redmarker.png`} /> = Parking Facility
                </div>
                <div style={{ display: 'flex' }}>
                  <img alt="" src={`/img/selectedmarker.png`} /> = Selected Parking Facility
                </div>
              </div>
              <Button style={{ marginTop: '10px' }} primary disabled={!selectedFacility || spots < 1} content="Finalize Reservation" onClick={onCreateReservation} />
            </Grid.Column>
            <Grid.Column width={3} only="tablet computer">
              {selectedFacility ? (
                <div>
                  <Header as="h4" content="Selected Facility Details" />
                  <div>Type: {selectedFacility.isLot ? 'Lot' : 'Garage'}</div>
                  {!selectedFacility.isLot ? (
                    <div>
                      Clearance: {selectedFacility.clearanceFeet}'{selectedFacility.clearanceInches}''
                    </div>
                  ) : null}
                  <Header as="h4" content="Directions to facility" />
                  <div className="directions" dangerouslySetInnerHTML={{ __html: selectedFacility.directions }}></div>
                </div>
              ) : (
                selectedFacility
              )}
            </Grid.Column>
            <Grid.Column width={16} only="mobile">
              <Header as="h4" content="Select Parking Spot" />
              <Map center={{ lat: parseFloat(venue.lat), lng: parseFloat(venue.lng) }} zoom={14}>
                <Marker
                  position={{ lat: parseFloat(venue.lat), lng: parseFloat(venue.lng) }}
                  title={venue.name}
                  address={`${venue.address}, ${venue.city}, ${venue.state} ${venue.zip}`}
                  icon={`/img/bluemarker.png`}
                />

                {inventory().map((i, idx) => (
                  <Marker
                    key={idx}
                    position={{ lat: parseFloat(i.facility.lat), lng: parseFloat(i.facility.lng) }}
                    title={i.facility.name}
                    address={`${i.facility.address}, ${i.facility.city}, ${i.facility.state} ${i.facility.zip}`}
                    icon={selectedFacility && selectedFacility.id === i.facility.id ? `/img/selectedmarker.png` : null}
                  />
                ))}
              </Map>
              <OptionList className="facility">
                {inventory().map((i, idx) => (
                  <div>
                    <FacilityOption
                      key={idx}
                      facility={{ ...i.facility, inventoryId: i.id, selected: selectedFacility ? selectedFacility.id === i.facility.id : false }}
                      onClick={onFacilitySelect}
                      rate={i.rate}
                    />
                    {selectedFacility ? (
                      selectedFacility.id === i.facility.id ? (
                        <div>
                          <Header as="h4" content="Selected Facility Details" />
                          <div>Type: {selectedFacility.isLot ? 'Lot' : 'Garage'}</div>
                          {!selectedFacility.isLot ? (
                            <div>
                              Clearance: {selectedFacility.clearanceFeet}'{selectedFacility.clearanceInches}''
                            </div>
                          ) : null}
                          <Header as="h4" content="Directions to facility" />
                          <div className="directions" dangerouslySetInnerHTML={{ __html: selectedFacility.directions }}></div>
                          <Button
                            style={{ margin: 'auto', display: 'block', marginTop: '10px' }}
                            primary
                            disabled={!selectedFacility}
                            content="Finalize Reservation"
                            onClick={onCreateReservation}
                          />
                        </div>
                      ) : null
                    ) : null}
                  </div>
                ))}
              </OptionList>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

FacilitySelection.propTypes = {};

export default FacilitySelection;
